import { useCallback, useEffect, useRef, useState } from "react";
import {
  MDBAlert,
  MDBBtn,
  MDBCheckbox,
  MDBCol,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSpinner,
  MDBTextArea,
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import AddExterNum from "../../../views/popups/misc/AddExterNum";
import LunaGreeting from "./LunaGreeting";
import LunaLocation from "./LunaLocation";
import LunaHuntGroup from "./LunaHuntGroup";
import LunaCallQueues from "./LunaCallQueues";
import LunaUsers from "./LunaUsers";
import LunaAutoAttendant from "./LunaAutoAttendant";
import LunaVMBox from "./LunaVMBox";
import LunaExternalNumber from "./LunaExternalNumber";
import LunaHumanOperator from "./LunaHumanOperator";
import {
  getSpecificLunaScheduleDetails,
  updateLunaDetails,
} from "../../../apiclients/streamsapi_bridge";
import { FormProvider, useForm } from "react-hook-form";
import SaveChanges from "../../topviews/saveCancel";
import TopSuccess from "../../header/TopSuccess";
import TopMessage from "../../header/TopMessage";
import { sanitizeAndLowercase } from "../../../apiclients/CommonUtils";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";

const OpenSchedule = ({
  isActive,
  scheduleId,
  lunaid,
  twentyFourSeven,
  basicActive,
}) => {
  const { t, i18n } = useTranslation();
  const [isloading, setIsloading] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [huntGroups, sethuntGroups] = useState([]);
  const [aaGroups, setaaGroups] = useState([]);
  // const [locations, setlocations] = useState([]);
  const [voiceMails, setvoiceMails] = useState([]);
  const [externalNumbers, setexternalNumbers] = useState([]);
  const [huntOperators, sethuntOperators] = useState({});
  const [holidayGreetings, setholidayGreetings] = useState([]);
  const [greetStatus, setgreetStatus] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState();
  const [uploadedFiles, setUploadedFiles] = useState();
  const [holidayCustomInfo, setholidayCustomInfo] = useState({});
  const [commonGreetingInfo, setcommonGreetingInfo] = useState({});
  const [commonGreetingIdName, setcommonGreetingIdName] = useState({});
  const [interErrorMessage, setinterErrorMessage] = useState("");
  const [regenerateFlag, setregenerateFlag] = useState(false);
  const [aaTextValue, setaaTextValue] = useState({});
  const [vmTextValue, setvmTextValue] = useState({});
  const [hgTextValue, sethgTextValue] = useState({});
  const [extTextValue, setextTextValue] = useState({});
  const [hgError, sethgError] = useState("");
  const [aaError, setaaError] = useState("");
  const [vmError, setvmError] = useState("");
  const [extError, setextError] = useState("");
  const [greetError, setgreetError] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [pdfInfo, setpdfInfo] = useState([]);

  const [users, setusers] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [infoError, setinfoError] = useState("");
  const [voiceType, setvoiceType] = useState(0);
  const voices = { 1: "Luna", 2: "Eric", 3: "Oscar", 4: "Serena" };

  const pendingResetsRef = useRef(0);
  const fallbackTimerRef = useRef(null);
  const loadInProgressRef = useRef(false);
  const containerRef = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);
  const section5 = useRef(null);
  const section6 = useRef(null);
  const section7 = useRef(null);
  const section8 = useRef(null);
  const section9 = useRef(null);
  const section10 = useRef(null);
  const section11 = useRef(null);

  const method = useForm({
    defaultValues: {
      deletepdfs: [],
      pdfs: [],
      greet: {
        msg: "",
        is_inherit_info: false,
        is_specific: false,
        info: "",
        edit_perm: [],
        weblink: "",
        scrap_info: "",
        status: 0,
      },
      hg: {
        is_perm_enabled: false,
        edit_perm: [],
      },
      aa: {
        is_perm_enabled: false,
        edit_perm: [],
      },
      vm: {
        is_perm_enabled: false,
        edit_perm: [],
      },
      ext_num: {
        is_perm_enabled: false,
        edit_perm: [],
      },
      hop: {
        title: "",
        val: "",
        name: "",
        phnumber: "",
        cid_pass: "-1",
        cid_pass_flag: null,
        hop_type: 0,
        extension: 0,
      },
      user: {
        is_presence_route: false,
        is_perm_enabled: false,
        val: "",
      },
    },
    shouldUnregister: false,
  });
  const {
    // register,
    // watch,
    handleSubmit,
    // setValue,
    formState: { isDirty, dirtyFields, errors },
    setError,

    reset,
  } = method;
  const companyName =
    JSON.parse(sessionStorage.getItem("admin_session"))?.company_name ?? "";
  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000);
    }
  }, [successMessage]);

  useEffect(() => {
    if ((lunaid || rerender) && isActive) {
      setextError("");
      setaaError("");
      sethgError("");
      setvmError("");
      setgreetError("");
      setUploadedFiles([]);
      // setSelectedItem(null);
      getSpecificScheduleDetails();
    }
  }, [lunaid, rerender, isActive]);

  const handleChildResetDone = useCallback(() => {
    pendingResetsRef.current = Math.max(0, pendingResetsRef.current - 1);
    if (pendingResetsRef.current === 0) {
      if (fallbackTimerRef.current) {
        clearTimeout(fallbackTimerRef.current);
        fallbackTimerRef.current = null;
      }
      setIsloading(false);
    }
  }, []);

  async function getSpecificScheduleDetails() {
    if (loadInProgressRef.current) return;
    loadInProgressRef.current = true;
    try {
      setRerender(false);
      setregenerateFlag(false);
      setSelectedItem(null);
      setIsloading(true);
      if (fallbackTimerRef.current) {
        clearTimeout(fallbackTimerRef.current);
        fallbackTimerRef.current = null;
      }
      const response = await getSpecificLunaScheduleDetails(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        lunaid,
        scheduleId
      );
      const lunaDetails = await response.json();
      console.log(
        "getSpecific getSpecificLunaScheduleDetails ::: " +
        JSON.stringify(lunaDetails)
      );
      const hgDetails = lunaDetails?.lunaPermissions?.hg ?? [];
      sethuntGroups(hgDetails);
      const hgText = hgDetails.reduce((acc, hg) => {
        acc[hg.code] = hg.info;
        return acc;
      }, {});
      sethgTextValue(hgText);
      const aaDetails = lunaDetails?.lunaPermissions?.aa ?? [];
      setaaGroups(aaDetails);
      const aaText = aaDetails.reduce((acc, aa) => {
        acc[aa.code] = aa.info;
        return acc;
      }, {});
      setaaTextValue(aaText);

      // setlocations(lunaDetails?.lunaPermissions?.loc ?? []);
      const vmdetails = lunaDetails?.lunaPermissions?.vm ?? [];
      setvoiceMails(vmdetails);
      const vmText = vmdetails.reduce((acc, vm) => {
        acc[vm.ext] = vm.info;
        return acc;
      }, {});
      setvmTextValue(vmText);

      // const externalDetails = lunaDetails?.lunaPermissions?.ext_nums ?? [];
      const externalDetails = (lunaDetails?.lunaPermissions?.ext_nums ?? []).map(item => ({
        ...item,
        formatted_phnumber: formattedNumber(item.phnumber)
      }));
      console.log("externalDetailsexternalDetails",externalDetails)
      setexternalNumbers(externalDetails);
      const extText = externalDetails.reduce((acc, ext) => {
        acc[ext.ph_id] = ext.info;
        return acc;
      }, {});
      setextTextValue(extText);

      sethuntOperators(lunaDetails?.lunaPermissions?.hop ?? {});
      const holidays = lunaDetails?.lunaPermissions?.greet?.hldysInfo ?? [];
      const holidaycustom = holidays.reduce((acc, holiday) => {
        acc[holiday.hlydyid] = {
          normalized_message: holiday.msg
            ? // ? sanitizeAndLowercase(holiday.msg)
            holiday.msg
            : "",
        };
        return acc;
      }, {});

      const commonGreetInfo = {
        normalized_message: lunaDetails?.lunaPermissions?.greet?.message
          ? // ? sanitizeAndLowercase(lunaDetails.lunaPermissions.greet.message)
          lunaDetails.lunaPermissions.greet.message
          : "",
      };
      setcommonGreetingInfo(commonGreetInfo);
      let greetingidName = {
        greet_id:
          lunaDetails?.lunaPermissions?.greet?.greet_id !== undefined
            ? lunaDetails.lunaPermissions.greet.greet_id
            : "",
        greet_name: lunaDetails?.lunaPermissions?.greet?.greet_name
          ? lunaDetails.lunaPermissions.greet.greet_name
          : "",
      };

      setcommonGreetingIdName(greetingidName);

      setholidayGreetings(holidays);
      setholidayCustomInfo(holidaycustom);
      setusers(lunaDetails?.lunaPermissions?.user ?? []);
      setgreetStatus(lunaDetails?.lunaPermissions?.greet?.status ?? 0);
      setpdfInfo(lunaDetails?.lunaPermissions?.greet?.pdfFilesInfo ?? []);
      setvoiceType(
        lunaDetails?.lunaPermissions?.greet?.voice_type !== undefined
          ? voices[parseInt(lunaDetails?.lunaPermissions?.greet?.voice_type)]
          : voices[1]
      );

      const isHuntEnabled = (lunaDetails?.lunaPermissions?.hg ?? []).some(
        (hg) => hg.flag === 1
      );

      const isAAEnabled = (lunaDetails?.lunaPermissions?.aa ?? []).some(
        (aa) => aa.flag === 1
      );
      const isVMEnabled = (lunaDetails?.lunaPermissions?.vm ?? []).some(
        (vm) => vm.flag === 1
      );
      const isExternalEnabled = (
        lunaDetails?.lunaPermissions?.ext_nums ?? []
      ).some((ext) => ext.flag === 1);

      const isUserEnabled = (lunaDetails?.lunaPermissions?.user ?? []).some(
        (usr) => usr.flag === 1
      );

      const isUserpresence = (lunaDetails?.lunaPermissions?.user ?? []).some(
        (usr) => usr.is_presence_route === 1
      );

      const primaryid =
        (lunaDetails?.lunaPermissions?.user ?? []).find(
          (user) => user.flag === 1
        )?.id ?? "";

      console.log(
        "isHuntEnabled ::::: " +
        isHuntEnabled +
        " isVMEnabled :::: " +
        isVMEnabled +
        " isAAEnabled ::: " +
        isAAEnabled +
        " isExternalEnabled ::: " +
        isExternalEnabled +
        " isUserEnabled ::: " +
        isUserEnabled +
        " isUserpresence ::: " +
        isUserpresence
      );
      reset({
        deletepdfs: [],
        pdfs: [],
        greet: {
          msg: lunaDetails?.lunaPermissions?.greet?.message ?? "",
          is_inherit_info:
            lunaDetails?.lunaPermissions?.greet?.is_inherit_info ?? false,
          is_specific:
            lunaDetails?.lunaPermissions?.greet?.is_specific ?? false,
          info: lunaDetails?.lunaPermissions?.greet?.info ?? "",
          scrap_info: lunaDetails?.lunaPermissions?.greet?.scrap_info ?? "",
          edit_perm: [],
          weblink: lunaDetails?.lunaPermissions?.greet?.weblink ?? "",
          status:
            lunaDetails?.lunaPermissions?.greet?.status !== undefined
              ? parseInt(lunaDetails?.lunaPermissions?.greet?.status)
              : 0,
        },
        hg: {
          is_perm_enabled: isHuntEnabled,
          edit_perm: [],
        },
        aa: {
          is_perm_enabled: isAAEnabled,
          edit_perm: [],
        },

        vm: {
          is_perm_enabled: isVMEnabled,
          edit_perm: [],
        },
        ext_num: {
          is_perm_enabled: isExternalEnabled,
          edit_perm: [],
        },
        hop: {
          title: lunaDetails?.lunaPermissions?.hop?.title ?? "",
          val: lunaDetails?.lunaPermissions?.hop?.val ?? "",
          name: lunaDetails?.lunaPermissions?.hop?.title ?? "",
          phnumber: lunaDetails?.lunaPermissions?.hop?.phnumber ?? "0",
          cid_pass: lunaDetails?.lunaPermissions?.hop?.cid_pass ?? "-1",
          cid_pass_flag:
            lunaDetails?.lunaPermissions?.hop?.cid_pass_flag !== undefined
              ? lunaDetails.lunaPermissions.hop.cid_pass_flag
              : true,
          hop_type: lunaDetails?.lunaPermissions?.hop?.hoptype ?? 0,
          extension: lunaDetails?.lunaPermissions?.hop?.extension ?? 0,
        },
        user: {
          is_presence_route: isUserpresence,
          is_perm_enabled: isUserEnabled,
          val: primaryid ?? "",
        },
      });
      // Count how many children will call their reset useEffect after receiving new props
      let pendingCount = 0;
      if (hgDetails.length > 0) pendingCount++;
      if (aaDetails.length > 0) pendingCount++;
      if (vmdetails.length > 0) pendingCount++;
      if (holidays.length > 0 && scheduleId === 4) pendingCount++;
      if (externalDetails.length > 0) pendingCount++;

      pendingResetsRef.current = pendingCount;

      if (pendingCount === 0) {
        setTimeout(() => setIsloading(false), 300);
      } else {
        fallbackTimerRef.current = setTimeout(() => {
          fallbackTimerRef.current = null;
          pendingResetsRef.current = 0;
          setIsloading(false);
        }, 3000);
      }
    } catch (error) {
      console.log("error:", error);
      setIsloading(false);
    } finally {
      loadInProgressRef.current = false;
    }
  }

  // Add this useEffect for polling
  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;


  console.log("dirtyFields ::::::::::: " + JSON.stringify(dirtyFields));
  function closeSave(e) {
    e.preventDefault();
    setextError("");
    setaaError("");
    sethgError("");
    setgreetError("");
    setvmError("");
    setUploadedFiles([]);
    // reset();
    setRerender(true);
    setSelectedItem(null);
  }

  const onSubmit = async (data) => {
    setinterErrorMessage("");
    setIsloading(true);
    console.log("dirtyfields :::::::::: " + JSON.stringify(dirtyFields));
    console.log(Object.keys(dirtyFields));
    setTimeout(async () => {
      const modifiedData = prepareFinalJson(dirtyFields, data);
      console.log(
        "modified Fields ::::::::::::::::: " + JSON.stringify(modifiedData)
      );
      let update = {};
      if (modifiedData) {
        const { greet, pdfs, ...remainingPermissions } = modifiedData || {};
        const formData = new FormData();
        formData.append("reqid", 150);
        formData.append(
          "siteid",
          JSON.parse(sessionStorage.getItem("admin_session")).siteid
        );
        formData.append("lunaid", lunaid);
        const scheduleType =
          scheduleId === 1
            ? "alltime"
            : scheduleId === 2
              ? "open"
              : scheduleId === 3
                ? "closed"
                : "holiday";
        formData.append("schedule_type", scheduleType);
        if (greet && Object.entries(greet).length > 0) {
          if (
            greet.info ||
            data.greet.info !== "" ||
            greet.weblink ||
            (pdfs && Array.isArray(pdfs)) ||
            data.greet.weblink !== ""
          ) {
            // greet.is_regeneration = true;
          }
          const { edit_perm, ...remaindData } = greet;
          if (data?.greet?.is_specific && edit_perm && edit_perm.length > 0) {
            edit_perm.forEach((item) => {
              const holidayInfo = holidayCustomInfo?.[item.hldy_id];
              if (
                item.msg &&
                holidayInfo?.normalized_message === item.msg &&
                // sanitizeAndLowercase(item.msg) &&

                holidayInfo.wave_file
              ) {
                formData.append(
                  `wav_${item.hldy_id}`,
                  holidayInfo.actual_wav_file
                );
              }
            });
            formData.append("greet", JSON.stringify(greet));
          } else {
            if (
              greet.msg &&
              commonGreetingInfo?.normalized_message === greet.msg &&
              // sanitizeAndLowercase(greet.msg) &&
              commonGreetingInfo.wave_file
            ) {
              formData.append(`wav_${0}`, commonGreetingInfo.actual_wav_file);
            }
            formData.append("greet", JSON.stringify(remaindData));
          }
        }
        if (
          remainingPermissions &&
          Object.entries(remainingPermissions).length > 0
        ) {
          formData.append(
            "luna_permissions",
            JSON.stringify(remainingPermissions)
          );
        }

        if (pdfs && Array.isArray(pdfs)) {
          if (
            regenerateFlag &&
            (!greet || Object.entries(greet).length === 0)
          ) {
            let greet = {};
            greet.is_regeneration = true;
            formData.append("greet", JSON.stringify(greet));
          }
          pdfs.forEach((file) => {
            formData.append("pdfs", file);
          });
        }

        for (let [key, value] of formData.entries()) {
          console.log(`form data fields :::::: ${key}: ${value}`);
        }

        let saverep = await updateLunaDetails(formData);
        console.log(saverep);
        console.log(`reponse of lunaa edit :::: ${JSON.stringify(saverep)}`);
        let saverepMsg = await saverep.json();
        console.log(
          "response of modified data :::" + JSON.stringify(saverepMsg)
        );
     
        if (saverepMsg.status && saverepMsg.status == "success") {
          setregenerateFlag(false);
          setUploadedFiles([]);
          setSelectedItem(null);
          setRerender(true);
          setgreetStatus(0);
           reset(data);
          setSuccessMessage(saverepMsg.message);
        } else {
          if (saverepMsg.message?.errors) {
            saverepMsg.message.errors.forEach((err) => {
              if (err.param_name === "greet.info") {
                setUploadedFiles([]);
              } else if (err.param_name === "greet.edit_perm") {
                setgreetError(err.message);
              }
              if (err.param_name === "hg") {
                sethgError(err.message);
              } else if (err.param_name === "aa") {
                setaaError(err.message);
              } else if (err.param_name === "vm") {
                setvmError(err.message);
              } else if (err.param_name === "ext_num") {
                setextError(err.message);
              } else {
                setError(err.param_name, {
                  type: "server",
                  message: err.message,
                });
                const fieldElement = document.querySelector(
                  `input[name="${err.param_name}"]`
                );
                if (fieldElement) {
                  console.log(fieldElement.offsetTop);
                }
                console.log(fieldElement);
                if (fieldElement) {
                  fieldElement.focus();
                  fieldElement.scrollIntoView({ behavior: "smooth" });
                }
              }
            });
            setIsloading(false);
          } else {
            setRerender(true);
            setinterErrorMessage(saverepMsg.message);
            setUploadedFiles([]);
          }
        }
      }
    }, 2000);
  };

  function prepareFinalJson(dirtyFields, data) {
    const modifiedData = {};
    console.log("dirtyFields :::::::::::::: " + JSON.stringify(dirtyFields));
    console.log("data :::::::::::::: " + JSON.stringify(data));

    function recurse(dirtyFields, data, modifiedData, path = "") {
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          const currentPath = path ? `${path}.${field}` : field;
          if (
            typeof data[field] === "object" &&
            !Array.isArray(data[field])
            //  && field !== "hop"
          ) {
            modifiedData[field] = {};
            recurse(
              dirtyFields[field],
              data[field],
              modifiedData[field],
              currentPath
            );
            if (
              field === "hg" ||
              field === "aa" ||
              field === "vm" ||
              field === "ext_num"
            ) {
              if (modifiedData[field]?.edit_perm?.length > 0) {
                modifiedData[field].is_perm_enabled =
                  data[field].is_perm_enabled;
              }
            }
          } else if (
            Array.isArray(data[field]) &&
            Array.isArray(dirtyFields[field]) &&
            (currentPath === "hg.edit_perm" ||
              currentPath === "aa.edit_perm" ||
              currentPath === "vm.edit_perm" ||
              currentPath === "ext_num.edit_perm" ||
              currentPath === "greet.edit_perm")
          ) {
            modifiedData[field] = data[field]
              .map((item, index) => {
                if (
                  dirtyFields[field][index]?.flag ||
                  dirtyFields[field][index]?.info ||
                  dirtyFields[field][index]?.phnumber ||
                  dirtyFields[field][index]?.title ||
                  dirtyFields[field][index]?.cid_pass ||
                  dirtyFields[field][index]?.cid_pass_flag ||
                  dirtyFields[field][index]?.msg
                ) {
                  return {
                    ...(currentPath !== "greet.edit_perm" && {
                      val:
                        currentPath === "vm.edit_perm"
                          ? item.id
                          : currentPath === "ext_num.edit_perm"
                            ? item.ph_id
                            : item.code,
                      // is_perm_enabled: item.is_perm_enabled,
                    }),
                    ...(currentPath === "greet.edit_perm" &&
                      dirtyFields[field][index]?.msg && {
                      hldy_id: item.hlydyid,
                      msg: item.msg,
                    }),
                    ...(currentPath === "vm.edit_perm" && {
                      vm_type: item.vmtype,
                    }),
                    ...(dirtyFields[field][index]?.flag && {
                      is_active: item.flag,
                    }),
                    ...(dirtyFields[field][index]?.info && {
                      info: item.info,
                    }),
                    ...(currentPath === "ext_num.edit_perm" &&
                      dirtyFields[field][index]?.phnumber && {
                      phnumber: item.phnumber,
                    }),
                    ...(currentPath === "ext_num.edit_perm" &&
                      dirtyFields[field][index]?.title && {
                      title: item.title,
                    }),
                    ...(currentPath === "ext_num.edit_perm" &&
                      dirtyFields[field][index]?.cid_pass && {
                      cid_pass: item.cid_pass,
                    }),
                    ...(currentPath === "ext_num.edit_perm" &&
                      dirtyFields[field][index]?.cid_pass_flag && {
                      cid_pass_flag: item.cid_pass_flag,
                    }),
                  };
                }
                return null;
              })
              .filter((item) => item !== null);
          } else {
            modifiedData[field] = data[field];
            if (
              currentPath.indexOf("hop") !== -1 &&
              data?.val
            ) {
              modifiedData.val = data.val;
              modifiedData.hop_type = data.hop_type;
            }
            // if(field === "hop") {
            //   modifiedData.hop = {
            //      ...data.hop,

            //   }
            // }
          }
        }
      }
    }

    recurse(dirtyFields, data, modifiedData);
    return modifiedData;
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll(".nav-link");
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      const stickyParent = lastLink.closest(".sticky-top");
      if (stickyParent && lastLink.classList.contains("active")) {
        lastLink.classList.remove("active");
        for (let i = 0; i < scrollspyLinks.length; i++) {
          const firstLink = scrollspyLinks[i];
          const parent = firstLink.closest(".sticky-top");
          if (parent) {
            firstLink.classList.add("active");
            break;
          }
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      setTimeout(() => {
        container.scrollTo({
          top: 5,
          behavior: "smooth",
        });

        setTimeout(() => {
          container.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 100);
      }, 500);
    }
  }, [basicActive]);

  return (
    <>
      <MDBRow>
        <MDBCol
          size="2"
          md="2"
          lg="2"
          sm="12"
          className="col-sm-100 pr-0 leftTabs"
        >
          <MDBScrollspy container={containerRef}>
            <MDBScrollspyLink targetRef={section3}>Greeting</MDBScrollspyLink>
            <MDBScrollspyLink targetRef={section5}>
              Hunt Groups
            </MDBScrollspyLink>
            {/* <MDBScrollspyLink targetRef={section6}>
              Call Queues
            </MDBScrollspyLink> */}
            <MDBScrollspyLink targetRef={section7}>Users</MDBScrollspyLink>
            <MDBScrollspyLink targetRef={section8}>
              Auto Attendants
            </MDBScrollspyLink>
            <MDBScrollspyLink targetRef={section9}>VM Box</MDBScrollspyLink>
            <MDBScrollspyLink targetRef={section10}>
              External Number
            </MDBScrollspyLink>
            <MDBScrollspyLink targetRef={section11}>
              Human Operator
            </MDBScrollspyLink>
          </MDBScrollspy>
        </MDBCol>

        <MDBCol
          size="12"
          md="10"
          sm="12"
          pr-0
          className="col-sm-100 pr-0 leftTabContent"
        >
          <FormProvider {...method}>
            <div
              id="element"
              ref={containerRef}
              className="scrollspy-example m-0"
            >
              <section ref={section3} id="greeting">
                <LunaGreeting
                  scheduleId={scheduleId}
                  twentyFourSeven={twentyFourSeven}
                  holidayGreetings={holidayGreetings}
                  greetStatus={greetStatus}
                  setgreetStatus={setgreetStatus}
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  lunaid={lunaid}
                  holidayCustomInfo={holidayCustomInfo}
                  setholidayCustomInfo={setholidayCustomInfo}
                  setcommonGreetingInfo={setcommonGreetingInfo}
                  commonGreetInfo={commonGreetingInfo}
                  commonGreetingIdName={commonGreetingIdName}
                  setinterErrorMessage={setinterErrorMessage}
                  setIsloading={setIsloading}
                  setregenerateFlag={setregenerateFlag}
                  regenerateFlag={regenerateFlag}
                  infoError={infoError}
                  setinfoError={setinfoError}
                  pdfInfo={pdfInfo}
                  setpdfInfo={setpdfInfo}
                  voiceType={voiceType}
                  greetError={greetError}
                  setgreetError={setgreetError}
                  isActive={isActive}
                  onResetDone={handleChildResetDone}
                />
              </section>

              <div className="routing-border"></div>

              <section ref={section5} id="hunt-groups">
                <LunaHuntGroup
                  huntGroups={huntGroups}
                  hgTextValue={hgTextValue}
                  hgError={hgError}
                  sethgError={sethgError}
                  onResetDone={handleChildResetDone}
                />
              </section>

              {/* <div className="routing-border"></div> */}

              {/* <section ref={section6} id="call-queues">
              <LunaCallQueues />
            </section> */}

              <div className="routing-border"></div>

              <section ref={section7} id="users">
                <LunaUsers
                  users={users}
                  setSuccessMessage={setSuccessMessage}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                />
              </section>

              <div className="routing-border"></div>

              <section ref={section8} id="auto-attendants">
                <LunaAutoAttendant
                  aaGroups={aaGroups}
                  aaTextValue={aaTextValue}
                  aaError={aaError}
                  setaaError={setaaError}
                  onResetDone={handleChildResetDone}
                />
              </section>

              <div className="routing-border"></div>

              <section ref={section9} id="vm-box">
                <LunaVMBox
                  voiceMails={voiceMails}
                  vmTextValue={vmTextValue}
                  vmError={vmError}
                  setvmError={setvmError}
                  onResetDone={handleChildResetDone}
                />
              </section>

              <div className="routing-border"></div>

              <section ref={section10} id="external-number">
                <LunaExternalNumber
                  externalNumbers={externalNumbers}
                  scheduleId={scheduleId}
                  lunaid={lunaid}
                  setSuccessMessage={setSuccessMessage}
                  isActive={isActive}
                  extTextValue={extTextValue}
                  setextError={setextError}
                  extError={extError}
                  onResetDone={handleChildResetDone}
                />
              </section>

              <div className="routing-border"></div>

              <section ref={section11} id="human-operator" style={{ paddingBottom: "34em" }}>
                <LunaHumanOperator
                  huntOperators={huntOperators}
                  scheduleId={scheduleId}
                  lunaid={lunaid}
                  setSuccessMessage={setSuccessMessage}
                />
              </section>
            </div>
            {isSave && (
              <SaveChanges
                onClose={closeSave}
                isdirtyFields={isSave}
                onSave={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleSubmit(onSubmit)();
                }}
              />
            )}
          </FormProvider>
        </MDBCol>
      </MDBRow>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      {successMessage && (
        <>
          <TopSuccess>
            <TopMessage successMessage={successMessage} />
          </TopSuccess>
        </>
      )}

      {interErrorMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setinterErrorMessage("")}
        >
          {interErrorMessage}
        </MDBAlert>
      )}
    </>
  );
};

export default OpenSchedule;
